import { Button } from "@mui/material";
import { useContext } from "react";
import { ThemeContext } from "../../../contexts";
import { ThemeFormSubHeaderProps } from "../../../types/components/themeFormSubHeader.types";

import "./themeFormSubHeader.css";

const ThemeFormSubHeader = ({ title, actionButtons, style }: ThemeFormSubHeaderProps): JSX.Element => {
	const { theme } = useContext(ThemeContext);

	return (
		<div className="theme-sub-header" style={{ ...style }}>
			<div className="title" style={{ color: theme.primary_color }}>
				{title}
			</div>
			<div className="action-buttons-container">
				{actionButtons?.map((actionButton, index) => {
					const { title, callback } = actionButton;
					return (
						<div key={index}>
							<Button
								onClick={callback}
								style={{
									backgroundColor: theme?.button?.background_color
										? theme?.button?.background_color
										: "grey",
									color: theme?.button?.color ? theme?.button?.color : "black",
									padding: "0.25rem"
								}}
								variant="contained"
							>
								{title}
							</Button>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ThemeFormSubHeader;
